// extracted by mini-css-extract-plugin
module.exports = {"dataSheetWrapper":"MeasurementsEnterTable_dataSheetWrapper__3PDq8"};